import * as React from 'react';
import {TypeImplementation} from '@packages/systems/wfdl';
import {TText} from '@packages/systems/wfdl-ast';
import {createAction} from '@packages/utilities/create-action';
import {Note as BaseNote, NoteLink} from '@packages/systems/spring';
import {
  getWebflowUrl,
  webflowDefaultHost,
} from '@packages/utilities/environment';
import {panelOpened} from '@packages/systems/panels';
import {LEFT_SIDEBAR_SETTING_SELECTED} from '@packages/systems/designer/actions';
import {
  useDesignerSelector,
  useDispatch,
  type DesignerStores,
} from '@packages/systems/designer/flux';

const pointerCursor = {cursor: 'pointer'} as const;

const selectSiteDataStore = (state: DesignerStores) => state.SiteDataStore;
const selectLastSearchIndex = (state: DesignerStores) =>
  state.SearchStore.lastSearchIndex;

const NoteComponent = () => {
  const dispatch = useDispatch();

  const {allowSiteSearch, shortName} = useDesignerSelector(selectSiteDataStore);
  const lastSearchIndex = useDesignerSelector(selectLastSearchIndex);
  const selectLeftSidebarSetting = createAction<
    typeof LEFT_SIDEBAR_SETTING_SELECTED,
    {settingName: string}
  >(LEFT_SIDEBAR_SETTING_SELECTED);

  const isIndexed = Boolean(lastSearchIndex);

  const openSearchSettingsPanel = () => {
    dispatch(selectLeftSidebarSetting({settingName: 'search'}));
    dispatch(panelOpened('siteSettings'));
  };

  const handleAddHostingClick = () => {
    if (allowSiteSearch) {
      openSearchSettingsPanel();
    } else {
      const hostingPath = `/dashboard/sites/${shortName}/hosting`;
      const searchParams = {
        ref: 'search_result_settings',
        cta: 'search',
      };

      window.open(
        webflowDefaultHost
          ? getWebflowUrl(hostingPath, searchParams)
          : `${hostingPath}?${new URLSearchParams(searchParams).toString()}`
      );
    }
  };
  const controlText = allowSiteSearch ? 'Go to Search Settings' : 'Add Hosting';

  const noteContent =
    'Previewing sample results. ' +
    (allowSiteSearch
      ? 'Publish your project to create your first index and start viewing real results.'
      : 'Add CMS or Business Hosting to unlock full search functionality.');

  return isIndexed && allowSiteSearch ? null : (
    <BaseNote
      style={{marginBlockStart: 8}}
      hasIcon={false}
      colorVariant="default"
    >
      {noteContent}
      <NoteLink style={pointerCursor} onClick={handleAddHostingClick}>
        {controlText}
      </NoteLink>
    </BaseNote>
  );
};

export const Note = TypeImplementation.Alias({
  type: TText,
  render: () => <NoteComponent />,
});
